import type { IAuthContext } from "./i-auth-context";

export interface IResolveAuthContextConfig {
  /** Apex host, e.g. "sp.davaco.cloud". */
  baseHost: string;
  /** Optional querystring (window.location.search) for local-dev override. */
  search?: string;
}

const AAD: IAuthContext = { kind: "aad", organization: null };

function devOverride(search: string | undefined): IAuthContext | null {
  if (search === undefined || search.length === 0) {
    return null;
  }
  const params = new URLSearchParams(search);
  if (params.get("idp") === "auth0") {
    const org = params.get("org");
    if (org !== null && org.length > 0) {
      return { kind: "auth0", organization: org };
    }
  }
  return null;
}

export function resolveAuthContext(
  hostname: string,
  config: IResolveAuthContextConfig
): IAuthContext {
  const host = hostname.trim()
.toLowerCase();
  const base = config.baseHost.trim()
.toLowerCase();

  if (host === base || host === `www.${base}`) {
    return AAD;
  }

  const suffix = `.${base}`;
  if (host.endsWith(suffix)) {
    const prefix = host.slice(0, host.length - suffix.length);
    const slug = prefix.split(".")
.filter(Boolean)
.pop() ?? "";
    if (slug.length > 0 && slug !== "www") {
      return { kind: "auth0", organization: slug };
    }
    return AAD;
  }

  return devOverride(config.search) ?? AAD;
}
